// import React from "react";
// // import "./iec.css";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Accordion,
// } from "react-bootstrap";

// const faqData = [
//   {
//     q: "What are the necessary technicalities you need to undergo to file an IEC?",
//     a: (
//       <>
//         <p>Well, you need to submit the following to file an IEC.</p>
//         <ul>
//           <li>A scanned digital signature of yours</li>
//           <li>A copy of your PAN Card</li>
//           <li>Your valid contact details (phone & email)</li>
//           <li>Branch office address proof</li>
//           <li>Bank account details matching IEC profile</li>
//           <li>Aadhar card copy matching PAN details</li>
//         </ul>
//       </>
//     ),
//   },
//   {
//     q: "How can you file a new application for IEC?",
//     a: (
//       <>
//       <p>You have to file a new application simply by –</p>
//     <ul>
//           <li>Logging to the Official DGFT website, https://dgft.gov.in/</li>
//           <li>Proceeding with the registration by tapping on the Register tab under 'Register as Importer/Exporter and</li>
//           <li>Finally, move to My Dashboard, then Importer Exporter Code, or shortly, IEC, and click on Apply for IEC.</li>
//           </ul>
//           </>

//           ),
//   },
//   {
//     q: "Why do you require registration on the official DGFT Website?",
//     a: (
//       <>
//       <p>You require a registration herein because –</p>
//     <ul>
//           <li>You can get your user profile to check & use as & when required.</li>
//           <li>You can track your applications through your profile easily.</li>
//           <li>You can have the opportunity to keep receiving notifications even when you do not access your profile.</li>
//           <li>You can seamlessly check your IEC Dashboard under a single window.</li>
//           </ul>
//           </>

//           ),
//   },
//   {
//     q: "How can you create a user account on DGFT Website?",
//    a: (
//       <>
//       <p>You can effortlessly create a profile on DGFT Website by following these steps!</p>
//     <ul>
//           <li>Go to the DGFT website first and head to the registration column. In this regard, your navigation link is https://dgft.gov.in .</li>
//           <li>Next, you have to tap on Login under the Register Column.</li>
//           <li>Once the registration form opens, enter the requisite details asked for!</li>
//          <li>When you complete this form and click okay, an OTP will reach your phone or email, and you have to enter it again!</li>
//          <li>That's all! Your registration stands triumphant, and a temporary password shall reach your email. You can now use it to log in and change further!</li>
//           </ul>
//           </>

//           ),
//   },
//   {
//     q: "What happens when your Bank Details get validated?",
//      a: (
//       <>
//       <p>Remember that you must provide authentic bank details matching your profile name! Only then will your bank details get validated via PFMS, and you can see the results on your profile Dashboard within 24 hours! During this time –</p>
//     <ul>
//           <li>You will be immediately issued your IEC.</li>
//           <li>The risk of your IEC filing shall get marked in RMS.</li>
//           <li>In case of a successful validation, the RMS flag disappears.</li>
//          <li>While in case of a failed validation, the RMS flag shall stand visible, as your supporting documents are yet to be verified.</li>
//           </ul>
//           </>

//           ),
//   },
//   {
//     q: "How to know if your payment is successful or not?",
//     a: <p>When your payment is successful, you will receive an acknowledgment message that says your application for IEC with File No. xxxxxxx is successful. You can track your application status by clicking on Track Status and printing a copy therein!</p>,
//   },
//   {
//     q: "How to print your IEC Certificate?",
//    a: (
//       <>
//        <p>You can easily print your IEC Certificate by following the given steps!</p>
//        <p>First & foremost, you have to navigate to https://dgft.gov.in.</p>
//        <p>Here, you shall get an option to enter your user name & password to log in.</p>
//     <ul>
//           <li>Once you enter your profile, straightaway head to the Services column and click on the IEC button.</li>
//           <li>Can you find the Manage IEC option? Click to open it.</li>
//           <li>The application gets opened, and you can verify your details now.</li>
//          <li>Once you are done reading through it, you can tap on the Print IEC button and get your PDF displayed on the screen.</li>
//           </ul>
//           </>

//           ),
//   },
//   {
//     q: "How much time does it take to get a new IEC Certificate?",
//     a: <p>You can receive your new IEC Certificate immediately after your successful application submission. In case of issues, you can contact DGFT customer care!
// </p>,
//   },
// ];

// export default function IECPage() {
//   // const [openIndex, setOpenIndex] = useState(0);

//   return (

//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//               <Col lg={8}>
//                 <div>
//       <h1>IMPORTER-EXPORTER CODE (IEC)/(E-IEC)</h1>

//                    <h2>What Is IEC?</h2>
//         <p>
//           The Importer-Exporter-Code (IEC) is an important trade identification number that is mandatory for exports or imports. Nobody is allowed to import or export, except under an IEC number assigned by the DGFT. In the case of the import or export of services or technologies, the IEC is only required if the service or technology provider benefits from the foreign trade policy or deals with certain services or technologies.
//                   </p>
//                   <h2>Uses of the IEC:</h2>
//         <p>
//           It serves as a permit to expand your business in the international market. The IEC is a unique code, it does not expire; Therefore, no type of renewal is required; once an IEC has been awarded, no notification is required as all the information on the imported / exported goods is given, reducing the flow of illegal goods certain taxes paid on the export of goods.
//                   </p>
                  
//                   </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>

//             <Row className="g-4 align-items-start">
//                                       <Col lg={12} xl={12}>
//                 <div>
                  
//                   <h2>Situations where IEC is required</h2>
//         <ul>
//           <li>If an importer has to declare his shipments, the customs authorities need it.</li>
//           <li>If an importer sends money abroad via banks, then the bank needs it.</li>
//           <li>If an exporter has to send his shipments, then it is necessary at port</li>
//           <li>If the bank receives money in foreign currency directly into his bank account, the bank will ask for it.</li>
          
//         </ul>

//          <h2>Procedures</h2>
//         <p>
//          Foreign trade policy has amended from time to time, The central Govt of India has hereby amended the IEC related provisions under the below notifications (2015-2020)
//         </p>
    
//       {/* IEC Updation */}

//   <h2>IEC updation Validity:</h2>
//   <p>
//     Foreign trade policy has amended from time to time, The central Govt of
//     India has hereby amended the IEC related provisions under the below
//     notifications (2015-2020)
//   </p>


// {/* Notification 1 */}

//   <h2>Notification 1</h2>

//   <p>
//     As per the Govt. norms the IEC code has the time to update between April and June and the application updation is completely on Online for more details find the below points:
//   </p>

//   <p>As per the Notification – 58 (2015-2020)</p>

//   <ul>
//     <li>
//       1. The application Process for IEC and updation in IEC is completely online and IEC can be generated by the applicant as per the procedure detailed in the below mentioned link.
//     </li>
//     <li>
//       2.An IEC holder has to ensure that details in its IEC is updated electronically every year, during April – June period. In cases where there are changes in IEC details same also needs to be confirmed online.    </li>
//     <li>
//       3. An IEC shall be de-activated, if it is not updated within the prescribed time. An IEC so de-activated may be activated, on its successful updation. This would however be without prejudice to any other action taken for violation of any other provisions of the FTP.
//     </li>
//     <li>
//       4. An IEC may be also be flagged for scrutiny. IEC holders are required t ensure that any risks flagged by the system is timely addresses failing which the IEC shall be deactivated.
//     </li>
//   </ul>


// {/* Notification 2 */}

//   <h2>Notification 2</h2>

//   <p>
//     As per Notification 11 (2015–2020), Government extended registration date
//     up to July 2021.
//   </p>

//   <p><strong>Existing Provision:</strong></p>
//   <p>
//     An IEC holder has to ensure that details in its IEC is updated electronically every year, during April-June Period. In cases where there are no changes in IEC details same also needs to be confirmed online.
//   </p>

//   <p><strong>Revised Provision:</strong></p>
//   <p>
//    An IEC holder has to ensure that details in its IEC is updated electronically every year, during April-June Period. In cases where there are no changes in IEC details same also needs to be confirmed online.
//   </p>

//   <p>
//    In Cases where there are no changes in IEC details same also needs to be confirmed online.
//         </p>
//         <p>Period of Modification of IEC is extended for the year 2021 – 2022 only till 31-07-2021, and no fee shall be changed on modifications carried out in IEC during the period of up to 31st July 2021.</p>


// {/* Notification 3 */}

//   <h2>Notification 3</h2>

//   <p>
// As per the Trade Notice 18/2021-2022 Dated 20.09.2021, in reference to the Notification No. 58/2015- 2020 dated 12.02.2021, 11/2015-2020 dated 01.07.2021 and 16/2015-2020 dated 09.08.2021 whereby it was mandated by DGFT to all IEC holders to ensure that details in their IEC is updated electronically every year during April-June period (for which no user charges will be borne by the IEC holder). Based on representations received from the IEC holders who had not updated their IECs, the period of updation was extended upto 31st July 2021 and subsequently to 31st August 2021.  </p>

//   <p>
// It may further be noted that any IEC so de-activated, would have the opportunity for automatic reactivation without any manual intervention or a physical visit to the DGFT RA. For IEC re-activation after 06.10.2021, the said IEC holder may navigate to the DGFT website and update their IEC online. Upon successful updation the given IEC shall be activated again and transmitted accordingly to Customs system with the updated status.  </p>


// {/* Certificate */}

//   <h2>Certificate Of Import Export Code (IEC)</h2>
//   <p>
//     No export or import will be made with the aid of using any character without an Importer-Exporter Code (IEC) range until especially exempted. DGFT has lately brought the ability of issuing Importer Exporter Code in digital form (e-IEC).
//   </p>


// {/* Procedures */}

//   <h2>Procedures</h2>
//   <p>
//     For issuance of e-IEC a utility may be made on line on DGFT website. Applicants can add the files and pay the desired rate via Net banking. Processing of such packages with the aid of using Regional Authority (RAs) of DGFT might be completed on line and a digitally signed e-IEC might usually be issued/ e-mailed to the applicant.
//   </p>

//   <p>
//     In case the utility is incomplete or in any other case ineligible, the identical will be rejected and a Rejection letter/email (with motives for rejection) might be dispatched to the applicant.
//   </p>

//   <p>
//     Application for trouble of e-IEC also can be crafted from e Biz platform.
//   </p>


// {/* Assistance */}

//   <h2>How Apex Services Assist</h2>
//   <p>
//     We may also help you in documentation, online submitting of utility and Coordination with Concerned Authority for issuance of Certificate of Importer Exporter Code.
//   </p>

//    </div>
//                                 </Col>
//             </Row>
//             </Container>
//                     </section>
            
//   {/* <p>For more details Contact us: +91 7288077744</p> */}

//       <section className="py-5 bg-light faq-section">
//                         <Container>
//                           <h2 className="mb-4 faq-title">
//                  Frequently Asked qs on Importer-Exporter Code (IEC)/(E-IEC)
//                </h2>
//       <Accordion defaultActiveKey="0" className="custom-faq">
//                  {faqData.map((f, i) => (
//                    <Accordion.Item eventKey={String(i)} key={i}>
//                      <Accordion.Header>{f.q}</Accordion.Header>
//                      <Accordion.Body>{f.a}</Accordion.Body>
//                    </Accordion.Item>
//                  ))}
//                </Accordion>
//              </Container>
//              </section>
//       </div>
//       </>
//   );
// }

import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaFileInvoice,
  FaHandsHelping
} from "react-icons/fa";

const faqData = [
  {
    q: "What documents are required for IEC?",
    a: (
      <ul className="custom-list">
        <li><FaCheckCircle /> PAN Card</li>
        <li><FaCheckCircle /> Aadhaar Card</li>
        <li><FaCheckCircle /> Address Proof</li>
        <li><FaCheckCircle /> Bank Details</li>
      </ul>
    ),
  },
  {
    q: "How long does IEC take?",
    a: <p>Usually issued within 1–2 working days.</p>,
  },
  {
    q: "Is renewal required?",
    a: <p>No renewal. Only annual update required.</p>,
  },
];

export default function IECPage() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">

            <Col lg={8}>
              <h1>
                Importer Exporter Code (IEC)
              </h1>

              <p>
                The Importer Exporter Code (IEC) is a mandatory registration issued
                by DGFT for businesses involved in international trade. It is a
                10-digit unique identification number required for importing and
                exporting goods and services from India.
              </p>

              <p>
                IEC acts as a key business identification for global trade,
                enabling smooth customs clearance, foreign payments, and
                international transactions.
              </p>
            </Col>

            <Col lg={4}>
              {/* You can add your assistance section here */}
            </Col>

          </Row>

          {/* IMPORTANCE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Why IEC is Important
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Legal authorization for import and export</li>
            <li><FaCheckCircle /> Required for foreign transactions</li>
            <li><FaCheckCircle /> Helps expand business globally</li>
            <li><FaCheckCircle /> No renewal required</li>
            <li><FaCheckCircle /> Lifetime validity</li>
          </ul>

          {/* WHERE REQUIRED */}
          <h2 className="section-title">
            <FaList className="icon" /> Where IEC is Required
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Importing goods through customs</li>
            <li><FaCheckCircle /> Exporting goods internationally</li>
            <li><FaCheckCircle /> Receiving foreign currency payments</li>
            <li><FaCheckCircle /> Sending payments abroad</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> IEC Registration Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Register on DGFT portal</li>
            <li><FaCheckCircle /> Fill IEC application form</li>
            <li><FaCheckCircle /> Upload required documents</li>
            <li><FaCheckCircle /> OTP verification</li>
            <li><FaCheckCircle /> Receive IEC certificate</li>
          </ul>

          {/* VALIDITY */}
          <h2 className="section-title">
            <FaFileInvoice className="icon" /> IEC Validity
          </h2>

          <p>
            IEC is valid for a lifetime and does not require renewal. However,
            businesses must update their IEC details annually between April and June.
            Failure to update may lead to temporary deactivation.
          </p>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Benefits of IEC
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Easy global market access</li>
            <li><FaCheckCircle /> No compliance burden of renewal</li>
            <li><FaCheckCircle /> Simplifies import-export procedures</li>
            <li><FaCheckCircle /> Builds business credibility</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we assist you with complete IEC registration
            including documentation, online filing, and coordination with DGFT.
            Our team ensures fast approval and hassle-free processing so you can
            focus on growing your business globally.
          </p>

          {/* FAQ */}
           <h2 className="section-title mt-4">Frequently Asked Questions</h2>
          
                    <Accordion defaultActiveKey="0" className="custom-faq">
                      {faqData.map((f, i) => (
                        <Accordion.Item eventKey={String(i)} key={i}>
                          <Accordion.Header>{f.q}</Accordion.Header>
                          <Accordion.Body>{f.a}</Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>

        </Container>
      </section>
    </div>
  );
}


// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Accordion,
// } from "react-bootstrap";

// const faqData = [
//   {
//     q: "What documents are required for IEC?",
//     a: (
//       <ul>
//         <li>PAN Card</li>
//         <li>Aadhaar Card</li>
//         <li>Address Proof</li>
//         <li>Bank Details</li>
//       </ul>
//     ),
//   },
//   {
//     q: "How long does IEC take?",
//     a: <p>Usually issued within 1–2 working days.</p>,
//   },
//   {
//     q: "Is renewal required?",
//     a: <p>No renewal. Only annual update required.</p>,
//   },
// ];

// export default function IECPage() {
//   return (
//     <div className="iec-page">

//       {/* HERO + FORM */}
//       <section className="hero-section">
//         <Container>
//           <Row className="align-items-start g-5">

//             {/* LEFT CONTENT */}
//             <Col>
//               <h1>
//                 Importer Exporter Code (IEC) Registration
//               </h1>

//               <h2>What is IEC?</h2>
//               <p>
//                 The Importer Exporter Code (IEC) is a mandatory registration
//                 issued by DGFT for businesses involved in international trade.
//                 It is a 10-digit unique number required for importing and
//                 exporting goods and services from India.
//               </p>

//               <p>
//                 IEC acts as a primary business identification in global markets
//                 and is required for customs clearance, foreign payments, and
//                 international transactions.
//               </p>

//               <h2>Why IEC is Important?</h2>
//               <p>
//                 IEC enables businesses to expand globally by allowing legal
//                 import and export operations. It is required by customs and
//                 banks for international trade transactions.
//               </p>

//               <ul>
//                 <li>Legal authorization for import/export</li>
//                 <li>Required for foreign payments</li>
//                 <li>Helps expand business globally</li>
//                 <li>No renewal required</li>
//               </ul>
//             </Col>

//             {/* RIGHT FORM (ONLY CARD) */}
//             {/* <Col lg={4}>
//               <div className="form-card">
//                 <h5>Get Free Consultation</h5>

//                 <Form>
//                   <Form.Control className="mb-3" placeholder="Name" />
//                   <Form.Control className="mb-3" placeholder="Email" />
//                   <Form.Control className="mb-3" placeholder="Phone" />
//                   <Form.Control className="mb-3" placeholder="Subject" />

//                   <Button className="w-100 submit-btn">
//                     Get Started
//                   </Button>
//                 </Form>
//               </div>
//             </Col> */}

//           </Row>
//         </Container>
//       </section>

//       {/* CONTENT SECTION */}
//       <section className="content-section">
//         <Container>

//           <h2>Where IEC is Required</h2>
//           <p>
//             IEC is required at multiple stages of international trade. Without
//             IEC, import and export transactions cannot be processed.
//           </p>

//           <ul>
//             <li>Importing goods through customs</li>
//             <li>Exporting goods to other countries</li>
//             <li>Receiving foreign currency payments</li>
//             <li>Sending payments to international suppliers</li>
//           </ul>

//           <h2>IEC Registration Process</h2>
//           <p>
//             The IEC registration process is completely online and simple. The
//             applicant needs to register on the DGFT portal, fill the application,
//             upload documents, and complete OTP verification.
//           </p>

//           <p>
//             After successful submission, IEC is usually issued within 1–2 working
//             days.
//           </p>

//           <h2>IEC Validity</h2>
//           <p>
//             IEC is valid for a lifetime. However, it must be updated every year
//             between April and June. Failure to update may result in deactivation.
//           </p>

//           <h2>IEC Certificate</h2>
//           <p>
//             Once approved, IEC is issued in digital format (e-IEC). It can be
//             downloaded anytime from the DGFT portal and used for all
//             import-export transactions.
//           </p>

//           <h2>Why Choose Us?</h2>
//           <p>
//             We provide complete assistance for IEC registration including
//             documentation, filing, and follow-up. Our process ensures quick
//             approval with minimal effort from your side.
//           </p>

//         </Container>
//       </section>

//       {/* FAQ */}
//       <section className="faq-section">
//         <Container>
//           <h2 className="mb-4">Frequently Asked Questions</h2>

//           <Accordion defaultActiveKey="0">
//             {faqData.map((f, i) => (
//               <Accordion.Item eventKey={String(i)} key={i}>
//                 <Accordion.Header>{f.q}</Accordion.Header>
//                 <Accordion.Body>{f.a}</Accordion.Body>
//               </Accordion.Item>
//             ))}
//           </Accordion>
//         </Container>
//       </section>

//     </div>
//   );
// }